window.addEventListener('unhandledrejection', function(event) {
  if (event.reason && event.reason.name === 'AbortError') {
    event.preventDefault()
  }
})